<template>
	<div>
		<div class="d-flex align-items-center justify-content-between mb16">
			<Icon v-if="isMobile" name="arrow-left" class="pointer" @click="close" />
			<h4 class="text-black neue fw-medium mb-0 lh28 pr24 fsp20" :class="{ 'flex-grow-1 text-center': isMobile }">
				{{ $t('views.Keyts.New.8') }}
			</h4>
			<Icon v-if="!isMobile" name="close" class="pointer" @click="close" />
		</div>
		<div class="bg-white rounded12" :class="{ 'p24': !isMobile }">
			<div>
				<div class="mb16">
					<div>
						<label class="fsp14 neue-roman lh20 mb8">{{ $t('views.Keyts.New.2') }}</label>
						<span class="require"> *</span>
					</div>
					<SelectSimple			
						id='type'
						:dataValue="data.type"
						:invalid="type_c"
						:require="true"
						:first='true'
						:keywords.sync='acc_types'
						@updateParentState="updateState"
						:defaultValue="$t('views.Keyts.New.13')"
					/>
				</div>
				<div class="mb16">
					<label for="name" class="fsp14 neue-roman lh20 mb8">{{ $t('views.Keyts.New.4') }}</label>
					<InputSimple 
						type='text' 
						id='name'
						:dataValue="data.name"
						:placeholder="$t('views.Keyts.New.9')"
						@updateParentState="updateState"
					/>
				</div>
				<div class="mb16">
					<div>
						<label class="fsp14 neue-roman lh20 mb8">{{ $t('views.Keyts.New.3') }}</label>
						<span class="require"> *</span>
					</div>
					<SelectSimple
						id='curr'
						:invalid="curr_c"
						:isSearch="true"
						:dataValue="data.curr"
						:defaultValue="$t('views.Keyts.New.10')"
						:hotUpdate="true"
						require
						:keywords.sync='currencies'
						:isFilterSelect="true"
						@updateParentState="updateState"
					/>
				</div>
			</div>
			<div v-if="data.curr && vaData" class="bg-light-blue rounded12 p16 border-full">
				<CustomSelectButton
					class="w-100 sections"
					v-model:modelValue="section"
					:small="true"
					:options="[
						{ label: $t('components.service.modal.AssetDetails.7'), value: 0 }, 
						{ label: $t('components.service.modal.AssetDetails.8'), value: 1 }, 
						{ label: $t('components.service.modal.AssetDetails.9'), value: 2 }, 
						{ label: $t('components.service.modal.AssetDetails.10'), value: 3 }, 
						{ label: $t('components.service.modal.AssetDetails.11'), value: 4 }
					]" 
				/>
				<div>
					<div v-if="section === 0" class="mt24 text-black">
						<div class="d-flex flex-column gap-3" :class="{ 'fsp12': isMobile }">
							<div class="d-flex align-items-center justify-content-between lh20 fsp14">
								<div class="primary-grey neue-roman text-nowrap">{{ $t('components.service.modal.AssetDetails.18') }}</div>
								<div class="d-flex align-items-center min-w-0">
									<div v-if='vaData.curr.owner_keyt_alias' class="ml16 text-truncate min-w-0">{{ sbstring(vaData.curr.owner_keyt_alias) }}</div>
									<span v-else class="ml16 text-truncate">{{ vaData.curr.owner_keyt }}</span>
									<Icon :name="'copy'" class="ml4 c20 pointer" :class="{ 'c16': isMobile }" @click.stop="copy(vaData.curr.owner_keyt_alias ? vaData.curr.owner_keyt_alias : vaData.curr.owner_keyt)" />
								</div>
							</div>
							<div class="d-flex align-items-center justify-content-between lh20 fsp14">
								<div class="primary-grey neue-roman text-nowrap ">{{ $t('components.service.modal.AssetDetails.19') }}</div>
								<div class="ml16 text-truncate min-w-0">{{ vaData.curr.name }}</div>
							</div>
							<div class="d-flex align-items-center justify-content-between lh20 fsp14">
								<div class="primary-grey neue-roman text-nowrap">{{ $t('components.service.modal.AssetDetails.5') }}</div>
								<div class="ml16 text-truncate min-w-0">{{ vaData.curr.currency }}</div>
							</div>
							<div class="d-flex align-items-center justify-content-between lh20 fsp14">
								<div class="primary-grey neue-roman text-nowrap">{{ $t('components.service.modal.AssetDetails.6') }}</div>
								<div class="ml16 min-w-0 text-truncate">{{ vaData.curr.responsible == '0' ? $t('views.ShowInfoVA.28') : $t('views.ShowInfoVA.24') }}</div>
							</div>
							<div class="d-flex align-items-center justify-content-between lh20 fsp14">
								<div class="primary-grey neue-roman text-nowrap">{{ $t('components.service.modal.AssetDetails.20') }}</div>
								<div class="d-flex align-items-center min-w-0">
									<div class="text-end ml16 text-truncate">{{ vaData.curr.owner_name }}</div>
									<router-link :to="`/corr_info?uid=${vaData.curr.uid}`" target="_blank">
										<Icon 
											name="external-link" 
											:active="false" 
											class="ml4 c20 pointer" 
											:class="{ 'c16': isMobile }" 
										/>
									</router-link>
								</div>
							</div>
							<div v-if="vaData.blockchain_type" class="d-flex align-items-center justify-content-between lh20 fsp14">
								<div class="primary-grey neue-roman text-nowrap">{{ $t('components.service.modal.AssetDetails.34') }}</div>
								<div class="text-end ml16 min-w-0 text-truncate">{{ vaData.curr.blockchain_type }}</div>
							</div>
						</div>
					</div>
					<div v-else-if="section === 1" class="mt24 text-black">
						<div class="d-flex flex-column gap-3" :class="{ 'fsp12': isMobile }">
							<div class="d-flex align-items-center justify-content-between lh20 fsp14">
								<div class="primary-grey neue-roman">{{ $t('components.service.modal.AssetDetails.35') }}</div>
								<div>{{ vaData.curr.fiat == '1' ? $t('components.service.modal.AssetDetails.36') : $t('components.service.modal.AssetDetails.37') }}</div>
							</div>
							<div class="d-flex align-items-center justify-content-between lh20 fsp14">
								<div class="primary-grey neue-roman">{{ $t('components.service.modal.AssetDetails.13') }}</div>
								<div>{{ vaData.curr.precision }}</div>
							</div>
							<div class="d-flex align-items-center justify-content-between lh20 fsp14">
								<div class="primary-grey neue-roman">{{ $t('components.service.modal.AssetDetails.14') }}</div>
								<div>{{ vaData.curr.current_emission }}</div>
							</div>
							<div class="d-flex align-items-center justify-content-between lh20 fsp14">
								<div class="primary-grey neue-roman">{{ $t('components.service.modal.AssetDetails.15') }}</div>
								<div>{{ vaData.curr.max_emission }}</div>
							</div>
							<div class="d-flex align-items-center justify-content-between lh20 fsp14">
								<div class="primary-grey neue-roman">{{ $t('components.service.modal.AssetDetails.16') }}</div>
								<div v-if="vaData.curr.bind_curr">
									{{ vaData.curr.bind_custom_count }} 
									{{ vaData.curr.currency }} = 
									{{ vaData.curr.bind_count }}
									{{ $store.getters.get_curr(vaData.curr.bind_curr).small_name }}
								</div>
							</div>
							<div class="d-flex align-items-center justify-content-between lh20 fsp14">
								<div class="primary-grey neue-roman">{{ $t('components.service.modal.AssetDetails.17') }}</div>
								<span v-if="vaData.curr.cover_percent !== '0.00'">
									{{ vaData.curr.cover_percent }}%
								</span>
							</div>
						</div>
					</div>
					<div v-else-if="section === 2" class="mt24 text-black">
						<div class="d-flex flex-column gap-3" :class="{ 'fsp12': isMobile }">
							<div class="d-flex align-items-center justify-content-between lh20 fsp14">
								<div class="primary-grey neue-roman">{{ $t('components.service.modal.AssetDetails.22') }}</div>
								<span>
									<Icon v-if="vaData.curr.access_atm_buy == 1" name="check-green" class="c20" />
									<Icon v-else name="circle-x" class="c20" />
								</span>
							</div>
							<div class="d-flex align-items-center justify-content-between lh20 fsp14">
								<div class="primary-grey neue-roman">{{ $t('components.service.modal.AssetDetails.23') }}</div>
								<span>
									<Icon v-if="vaData.curr.access_atm_sell == 1" name="check-green" class="c20" />
									<Icon v-else name="circle-x" class="c20" />
								</span>
							</div>
							<div class="d-flex align-items-center justify-content-between lh20 fsp14">
								<div class="primary-grey neue-roman">{{ $t('components.service.modal.AssetDetails.24') }}</div>
								<span>
									<Icon v-if="vaData.curr.access_offer == 1" name="check-green" class="c20" />
									<Icon v-else name="circle-x" class="c20" />
								</span>
							</div>
							<div class="d-flex align-items-center justify-content-between lh20 fsp14">
								<div class="primary-grey neue-roman">{{ $t('components.service.modal.AssetDetails.25') }}</div>
								<span>
									<Icon v-if="vaData.curr.access_p2p == 1" name="check-green" class="c20" />
									<Icon v-else name="circle-x" class="c20" />
								</span>
							</div>
						</div>
					</div>
					<div v-else-if="section === 3" class="mt24 text-black">
						<div class="d-flex flex-column gap-3" :class="{ 'fsp12': isMobile }">
							<div class="d-flex align-items-center justify-content-between lh20 fsp14">
								<div class="primary-grey mbp-8 neue-roman">{{ $t('components.service.modal.AssetDetails.27') }}</div>
								<div class="text-black neue">{{ vaData.curr.category }}</div>
							</div>
							<div>
								<div class="primary-grey mbp-8 neue-roman fsp14 lh20">{{ $t('components.service.modal.AssetDetails.28') }}</div>
								<div class="text-black neue-roman fsp14 lh20">{{ vaData.curr.mission }}</div>
							</div>
						</div>
					</div>
					<div v-else-if="section === 4" class="mt24 text-black">
						<div class="d-flex flex-column gap-3" :class="{ 'fsp12': isMobile }">
							<div v-for="(item, index) in vaData.links" :key="index">
								<div v-if="item.icon && item.text" class="d-flex justify-content-between align-items-center lh20 fsp14">
									<div class="d-flex align-items-center gap-2">
										<Icon :name="item.icon" class="c20" />
										<span class="primary-grey neue-roman text-nowrap">{{ item.text }}</span>
									</div>
									<div class="d-grid min-w-0">
										<span class="ml16 text-truncate pointer" @click="copy(item.value)">{{ item.value }}</span>
									</div>
								</div>
								<div v-else-if="!item.icon && !item.text">
									<div class="primary-grey neue-roman mb8" :class="{ 'fsp12 lh16': isMobile }">{{ $t('views.ShowInfoVA.30') }}</div> 
									<div class="neue-roman" :class="{ 'fsp12 lh16': isMobile }">{{ item.value }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="d-flex gap-2 mt24" :class="{ 'mobile-modal-buttons': isMobile }">
				<Button 
					@click="createKeyt"
					:name="$t('views.Keyts.New.11')" 
					:disabled="!data.type || !data.curr || data.curr == '-1'"
					class="h48 equal-width"
					type='btn-warning' 
				/>
				<Button 
					@click="close"
					:name="$t('views.Keyts.New.12')" 
					class="h48 equal-width"
					type='btn-outline-grey' 
				/>
			</div>
		</div>
	</div>
</template>

<script>
import Icon from '@/components/icons/Icon';
import Button from '@/components/service/Button';
import SelectSimple from '../SelectSimple.vue';
import InputSimple from '../InputSimple.vue';
import CustomSelectButton from '../CustomSelectButton.vue';

export default {
	components: {
		Icon,
		Button,
		InputSimple,
		SelectSimple,
		CustomSelectButton,
	},
	props: {
		close: [Function],
	},
	data() {
		return {
			data: {
                type: false,
                curr: false,
                name: false,
            },
            type_c: false,
            curr_c: false,
            name_c: false,
            acc_types: [],
            currencies: [],
            get_currency: false,
            section: 0,
			vaData: null,
		};
	},
	computed: {
		isMobile() {
			return this.$store.state.resize.w <= 768;
		},
	},
	async mounted() {
        const res = await this.axios.post('NewKeytInit');
		if (res.data.body.result) {
			return;
		}
		this.acc_types = res.data.body[0];
		let currs = res.data.body[1];
		if (this.$route.query.curr) {  
			let need = this.$route.query.curr;

			currs.sort((a, b) => {
				return a.code!= need ? 1 : -1;
			})
		}
		this.currencies = currs;

		// если получили get-парметр, то нужно найти валюту с заданным кодом
		this.getCurrValue();

		// если в селекте 1 значение, то нужно обновить state
		if (this.acc_types.length <= 1) {
			this.data.type = this.acc_types[0] ? this.acc_types[0].code : '';
		}
    },
	methods: {
		copy(text) {
            this.$lib.copyTextS(text, this.$store)
        },
		sbstring(str) {
            if (this.$store.state.resize.w < 1024 && !this.isMobile && str.length > 7) {
                return this.$lib.getTokenString(str, 4);
            } else if(this.isMobile) {
                return this.$lib.getTokenString(str, 12);
            } else if (this.$store.state.resize.w < 1200 && str.length > 12) {
                return this.$lib.getTokenString(str, 8);
            } else if (str.length > 30) {
                return this.$lib.getTokenString(str, 8);
            } 
            return this.$lib.getTokenString(str, 6);
        },
		updateState(state) {
            // console.log(state)
			if(state.id == 'curr' && state.value) {
				this.getCustomCurrParams(state.value);
			}
            this.data[state.id] = state.value;
            this[state.id + '_c'] = false;
        },
		async getCustomCurrParams(code) {
            const res = await this.axios.post('GetCustomCurrParams', {no_error_msg: true, data: {code: code}});
			if (res.data.body.result === '0') {
				const linksDataArray = [
					{code: '0', icon: 'va-host', text: this.$t('views.ShowInfoVA.21')},
					{code: '1', icon: 'va-white-book', text: this.$t('views.ShowInfoVA.22')},
					{code: '2', icon: 'va-mail', text: this.$t('views.ShowInfoVA.23')},
					{code: '3', icon: 'va-telegram', text: 'Telegram'},
					{code: '4', icon: 'va-twitter', text: 'Twitter'},
					{code: '5', icon: 'va-facebook', text: 'Facebook'},
					{code: '6', icon: 'whatsapp', text: 'WhatsApp'},
					{code: '7', icon: 'linkedin', text: 'LinkedIn'},
				];

				const vaDataCurr = res.data.body.advanced;

				const name = vaDataCurr.name_en ? vaDataCurr.name_en : vaDataCurr.name_ru;
				vaDataCurr.name = name;
				let tmp = {}
				tmp.curr = vaDataCurr;
				const links = res.data.body.tables[1].colvalues;
				const linksResult = linksDataArray.filter((link) => links.some((item) => item.code == link.code));

				linksResult.forEach((link) => {
					const linkItem = links.find(item => item.code == link.code);
					link.value = linkItem.value;
				});
				tmp.links = linksResult;
				tmp.code = code;

				this.vaData = tmp;
			} else {
				this.vaData = null;
			}
        },
        async createKeyt() {
			const res = await this.axios.post('NewKeyt', {data: this.data});
			if (res.data.body.result == '0') {
				this.close();
			}
        },
        checkData() {
            if (!this.data.type) {
                this.type_c = true;
            }
            if (!this.data.curr) {
                this.curr_c = true;
            }
        },
        getCurrName(curr) {
            let currName = '';
            const currElement = this.currencies.find(item => item.code == curr);
            if (currElement) {
                currName = currElement.code ? currElement.code : '';
            }

            return currName;
        },
        getCurrValue() {
            const currency = this.$route.query.curr;

            if (currency) {
                // this.get_currency = this.getCurrName(currency);
                this.updateState({id: 'curr', value: currency});
                // for rebuild
            }
        }
	},
};
</script>